// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"581e6792","397":"efd00407","626":"d77309ec","637":"5001033d"}[chunkId] + ".chunk.css";
};